'use client';

import { Button } from '#/components/ui/button';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { useT } from '#/i18n/client';

const ReactJson = dynamic(() => import('react-json-view'), { ssr: false });

export default function JsonPar({ data }: { data: any }) {
  const t = useT('tryCommon');
  const [collapsed, setCollapsed] = useState<number | boolean>(2);

  return (
    <div className="flex flex-col gap-4 h-full flex-1 overflow-auto">
      <div className="flex justify-end gap-2">
        <Button variant={'ghost'} onClick={() => setCollapsed(false)}>
          {t('json.expandAll')}
        </Button>
        <Button variant={'ghost'} onClick={() => setCollapsed(1)}>
          {t('json.collapseAll')}
        </Button>
      </div>
      {data && (
        <ReactJson
          displayDataTypes={false}
          displayObjectSize={false}
          name={false}
          src={data}
          collapsed={collapsed}
          theme={'bright:inverted'}
          enableClipboard={true}
        />
      )}
    </div>
  );
}
